var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { Modal, Button, Row, Col, RadioButton } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { useMutation, useQuery } from "react-query";
import { fetchPublisherData } from "../api/publisherService";
import { fetchUserByEmail, updateUserOrganizationRoles, } from "../api/userService";
import { RoleEnum } from "../types/RoleEnum";
import { needsAdminResolution } from "../utils/adminResolution";
import styles from "./AdminResolutionModal.module.css";
var roleOptions = [
    { role: RoleEnum.PUBLISHER_ADMIN, labelId: "ui-br-publishers.admin.resolution.role.admin" },
    { role: RoleEnum.PUBLISHER_GUARANTOR, labelId: "ui-br-publishers.admin.resolution.role.guarantor" },
];
var GuarantorRoleList = function (_a) {
    var guarantors = _a.guarantors, roleAssignments = _a.roleAssignments, onRoleChange = _a.onRoleChange;
    var formatMessage = useIntl().formatMessage;
    return guarantors.map(function (guarantor, index) {
        var key = guarantor.email || "guarantor-".concat(index);
        return (React.createElement(Row, { key: key },
            React.createElement(Col, { xs: 4 },
                React.createElement("strong", null,
                    guarantor.firstName,
                    " ",
                    guarantor.lastName),
                React.createElement("br", null),
                guarantor.email),
            roleOptions.map(function (_a) {
                var role = _a.role, labelId = _a.labelId;
                return (React.createElement(Col, { xs: 4, key: role },
                    React.createElement(RadioButton, { label: formatMessage({ id: labelId }), checked: roleAssignments[key] === role, onChange: function () { return onRoleChange(key, role); }, name: "role-".concat(key) })));
            })));
    });
};
export var AdminResolutionModal = function (_a) {
    var _b;
    var activeOrganization = _a.activeOrganization, onResolved = _a.onResolved, onDismiss = _a.onDismiss;
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var _c = useState({}), roleAssignments = _c[0], setRoleAssignments = _c[1];
    var publisher = useQuery(["publisher", activeOrganization.sourceId], function () { return fetchPublisherData(activeOrganization.sourceId, ky); }, {
        onSuccess: function (data) {
            if (data === null || data === void 0 ? void 0 : data.guarantors) {
                var initial_1 = {};
                data.guarantors.forEach(function (_a, index) {
                    var email = _a.email, roles = _a.roles;
                    var key = email || "guarantor-".concat(index);
                    initial_1[key] = (roles === null || roles === void 0 ? void 0 : roles.includes(RoleEnum.PUBLISHER_ADMIN))
                        ? RoleEnum.PUBLISHER_ADMIN
                        : RoleEnum.PUBLISHER_GUARANTOR;
                });
                setRoleAssignments(initial_1);
            }
        },
    }).data;
    var guarantors = (_b = publisher === null || publisher === void 0 ? void 0 : publisher.guarantors) !== null && _b !== void 0 ? _b : [];
    var hasAtLeastOneAdmin = Object.values(roleAssignments).some(function (role) { return role === RoleEnum.PUBLISHER_ADMIN; });
    var handleRoleChange = function (key, role) {
        setRoleAssignments(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = role, _a)));
        });
    };
    var _d = useMutation({
        mutationFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var guarantorsToSave, _i, guarantorsToSave_1, guarantor, key, selectedRole, user, roles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        guarantorsToSave = guarantors.filter(function (guarantor, index) { return roleAssignments[guarantor.email || "guarantor-".concat(index)]; });
                        _i = 0, guarantorsToSave_1 = guarantorsToSave;
                        _a.label = 1;
                    case 1:
                        if (!(_i < guarantorsToSave_1.length)) return [3 /*break*/, 5];
                        guarantor = guarantorsToSave_1[_i];
                        key = guarantor.email || "guarantor-".concat(guarantors.indexOf(guarantor));
                        selectedRole = roleAssignments[key];
                        if (!guarantor.email)
                            throw new Error("Guarantor ".concat(guarantor.firstName, " ").concat(guarantor.lastName, " has no email"));
                        return [4 /*yield*/, fetchUserByEmail(ky, guarantor.email)];
                    case 2:
                        user = _a.sent();
                        if (!(user === null || user === void 0 ? void 0 : user.id))
                            throw new Error("User not found for email: ".concat(guarantor.email));
                        roles = selectedRole === RoleEnum.PUBLISHER_ADMIN
                            ? [RoleEnum.PUBLISHER_ADMIN, RoleEnum.PUBLISHER_GUARANTOR]
                            : [RoleEnum.PUBLISHER_GUARANTOR];
                        return [4 /*yield*/, updateUserOrganizationRoles(ky, user.id, activeOrganization.id, roles)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 1];
                    case 5:
                        sessionStorage.removeItem("activeRoles");
                        sessionStorage.removeItem("activeOrganization");
                        return [2 /*return*/];
                }
            });
        }); },
        onSuccess: function () {
            onResolved();
        },
    }), saveAdminResolution = _d.mutate, isSaving = _d.isLoading, error = _d.error;
    var handleConfirm = function () {
        if (!hasAtLeastOneAdmin)
            return;
        saveAdminResolution();
    };
    var footer = (React.createElement("div", { className: styles.footer },
        React.createElement(Button, { onClick: onDismiss }, formatMessage({ id: "ui-br-publishers.button.cancel" })),
        React.createElement(Button, { buttonStyle: "primary", onClick: handleConfirm, disabled: !hasAtLeastOneAdmin || isSaving }, formatMessage({ id: "ui-br-publishers.admin.resolution.confirm" }))));
    // Safety net (RECEK-75667): with at most one guarantor there is nobody to choose from, so the dialog is not
    // rendered at all - neither while the publisher is loading, so it never flashes up.
    if (!needsAdminResolution(publisher === null || publisher === void 0 ? void 0 : publisher.guarantors)) {
        return null;
    }
    return (React.createElement(Modal, { open: true, label: formatMessage({
            id: "ui-br-publishers.admin.resolution.modal.title",
        }), footer: footer, dismissible: true, onClose: onDismiss },
        React.createElement("p", null, formatMessage({
            id: "ui-br-publishers.admin.resolution.modal.message",
        })),
        React.createElement(GuarantorRoleList, { guarantors: guarantors, roleAssignments: roleAssignments, onRoleChange: handleRoleChange }),
        !hasAtLeastOneAdmin && (React.createElement("p", { className: styles.validationError }, formatMessage({
            id: "ui-br-publishers.admin.resolution.validation.needAdmin",
        }))),
        error && (React.createElement("p", { className: styles.validationError }, String(error)))));
};
